"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pollone": {
    "e1a14b69": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "borrino": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d740abbe": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "bricco": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "06a56494": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "burcina-cantone-trotti": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4435bcb4": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "cangio": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f55c492": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac61b492": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "pizzo": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43cae0c3": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "b91aad67",
      "slug": "pollone",
      "name": "Pollone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;